import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateFundMNPZKGZH(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateFundMNPZKGZH({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNPZKGZH', id)
          .then((json) => {
            commit('updateFundMNPZKGZH', {
              id,
              data: json.Datas,
            });
            resolve(json.Datas);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
